import React from 'react'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import { ClassesType } from '../../types'
import ButtonWithLoader, { ButtonWithLoaderProps } from './ButtonWithLoader'

const useStyles = makeStyles(
  theme => ({
    button: {
      color: theme.colors.secondaryText,
      fontWeight: 400,
      backgroundColor: 'transparent',
      fontSize: '1.6rem',
      textTransform: 'none',
      textDecoration: 'underline',
      borderRadius: 0,
      padding: theme.spacing(0.75, 1),
      '&:not(:last-child)': {
        marginRight: theme.spacing(2),
      },
      '&&&&:hover': {
        boxShadow: 'none',
        textDecoration: 'underline',
        backgroundColor: 'rgba(1, 41, 74, 0.04)',
      },
    },
  }),
  { name: 'LinkButton' },
)

export interface LinkButtonProps extends ButtonWithLoaderProps {
  readonly classes?: ClassesType<typeof useStyles>
}

const LinkButton = ({
  className,
  children,
  classes: classesProp,
  ...rest
}: LinkButtonProps) => {
  const classes = useStyles({ classes: classesProp })

  return (
    <ButtonWithLoader
      className={classNames(className, classes.button)}
      {...rest}
    >
      {children}
    </ButtonWithLoader>
  )
}

export default LinkButton
